/** @jsx jsx */
import * as React from "react";
import { css, InterpolationWithTheme, jsx } from "@emotion/core";

interface ICardProps {
    css?: InterpolationWithTheme<any>;
    children?: any
    customCss?: any,
    showShadow?: boolean,
}

const cardCss: InterpolationWithTheme<any> = {
    backgroundColor: "#ffffff",
    minHeight: 1,
}

const cardShadow: InterpolationWithTheme<any> = {
    boxShadow: "0px 2px 14px 0px rgba(0, 0, 0, 0.1)"
}

export const Card: React.FC<ICardProps> = (props: ICardProps) => {
    let allCss = { ...cardCss as any, ...props.css as any, ...props?.customCss };
    if (props.showShadow) allCss = { ...allCss, ...cardShadow }
    return <div css={allCss}>
        {
            props.children
        }
    </div>
}